import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { ScoringParametrage } from "../../core/model/ScoringParametrage";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ScoringParametreService } from "../../core/service/scoring-parametre.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { first } from "rxjs/operators";

@Component({
  selector: "app-edit-scoring-parametre",
  templateUrl: "./edit-scoring-parametre.component.html",
  styleUrls: ["./edit-scoring-parametre.component.scss"],
})
export class EditScoringParametreComponent implements OnInit {
  @Input()
  set scoringParametrage(value: ScoringParametrage) {
    if (value) {
      this._scoringParametrage = { ...value };
      this.form2.patchValue({
        code: value.code,
        libelle: value.libelle,
      });
      this.cdr.detectChanges();
    }
  }
  get scoringParametrage(): ScoringParametrage {
    return this._scoringParametrage;
  }

  private _scoringParametrage: ScoringParametrage;

  form2: FormGroup;
  pressButton: Boolean = false;
  loading = false;

  constructor(
    private _scoringParametreService: ScoringParametreService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {
    this.form2 = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      libelle: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this._scoringParametrage = {
      ...this._scoringParametrage,
      ...this.form2.value,
    };

    this._scoringParametreService
      .update(this._scoringParametrage)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.activeModal.close(this._scoringParametrage);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
